import { authActions } from './slices/auth';
import { channelsActions } from './slices/channels';
import { eventsActions } from './slices/events';
import { loaderActions } from './slices/loader';
import { profileActions } from './slices/profile';
import { sessionActions } from './slices/session';
import { streamingPlatformsActions } from './slices/streamingPlatforms';

export {
  authActions,
  channelsActions,
  eventsActions,
  loaderActions,
  profileActions,
  sessionActions,
  streamingPlatformsActions
};
